import { useMutation } from 'react-query'

import { APIError } from '../../../../../../../utils'
import { useDefaultTradeName } from '../../../../../hooks/useDefaultTradeName'
import { deleteZervantInvoiceLogo } from '../../../query-api'

interface UseDeleteZervantInvoiceLogoProps {
  onError?: (error?: APIError) => void
  onSuccess?: (data: void) => void
}

export const useDeleteZervantInvoiceLogo = (props?: UseDeleteZervantInvoiceLogoProps) => {
  const { onError, onSuccess } = props || {}
  const { defaultTradeName, isLoading: isLoadingDefaultTradeName } = useDefaultTradeName()

  const {
    mutate,
    isLoading: isDeleting,
    ...rest
  } = useMutation(() => deleteZervantInvoiceLogo(defaultTradeName?._id || ''), {
    onSuccess,
    onError,
  })

  return { delete: mutate, isLoading: isLoadingDefaultTradeName || isDeleting, ...rest }
}
